<section class="preview-page">
    <h1 class="preview-title">DASH-3076 &mdash; alert response screens</h1>
    <p class="preview-note">
        Temporary local preview. Each button below opens one of the mockup's five states
        independently, backed by static mock data since the real endpoints are not built yet.
    </p>

    <div class="scenario-list">
        @for (scenario of scenarios; track $index) {
            <a
                class="scenario-card"
                [href]="scenario.href">
                <span class="scenario-title">{{ scenario.title }}</span>
                <span class="scenario-description">{{ scenario.description }}</span>
            </a>
        }
    </div>
</section>
